import { createRoute } from '@tanstack/react-router';
import Identity from '@modules/identity/presentation/pages/login';
import { rootRoute } from '@app/router/root';

export type IdentitySearchQuery = {
  hid: string;
  next: string;
};

export const IdentityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/identity',
  component: () => (
    <Identity />
  ),
  validateSearch: ({ hid, next }: IdentitySearchQuery): IdentitySearchQuery => ({ hid, next }),
});
